export default () => ({
  smallLabel: {
    marginTop: 32,
    marginBottom: 46
  },
  button: {
    minWidth: 255,
    marginBottom: 16
  }
});
